import { Range } from '../FilterTypes';

export const parseTimeOnMarketValue = (value: string, saleOrRent: 'for_sale' | 'for_rent' | 'sold'): Range => {
  if (value === 'No max' || value === 'No min') {
    return Range.create(null, null);
  }

  // For "sold" properties - these are absolute date ranges, not days on market
  if (saleOrRent === 'sold') {
    const soldMap: Record<string, number> = {
      'Last 1 week': 7,
      'Last 1 month': 30,
      'Last 6 months': 180,
      'Last 1 year': 365,
      'Last 2 years': 730,
      'Last 3 years': 1095,
      'Last 5 years': 1825,
      'More than 5 years': 1826, // this isnt going to be correct when implement sold dates
    };
    const maxDays = soldMap[value];
    return maxDays ? Range.create(null, maxDays) : Range.create(null, null);
  }

  // For buy/rent - extract number of days
  const match = value.match(/(\d+)/);
  if (!match) {
    return Range.create(null, null);
  }

  const days = parseInt(match[1]);

  // Handle ranges like "7-14 days"
  if (value.includes('-')) {
    const rangeMatch = value.match(/(\d+)-(\d+)/);
    if (rangeMatch) {
      const min = parseInt(rangeMatch[1]);
      const max = parseInt(rangeMatch[2]);
      return Range.create(min, max);
    }
  }

  // Handle "365+ days" or "more than" cases
  if (value.includes('+') || value.toLowerCase().includes('more than')) {
    return Range.create(days, null);
  }

  // Standard "less than X days" - set as max
  return Range.create(null, days);
};

/**
 * Format a Range value back to its display label
 * @param range - The Range value to format
 * @param options - Array of available option labels
 * @returns Display label matching the range
 */
export const formatTimeOnMarketValue = (range: Range | null, options: string[]): string => {
  if (!range || range.isEmpty()) {
    return 'No max';
  }

  // Handle "more than 365 days" case
  if (range.min && range.min >= 365 && !range.max) {
    return options.find(opt => opt.includes('+') || opt.toLowerCase().includes('more than')) || 'No max';
  }

  // Handle range cases like "7-14 days"
  if (range.min && range.max) {
    const match = options.find(opt => {
      const rangeMatch = opt.match(/(\d+)-(\d+)/);
      if (rangeMatch) {
        return parseInt(rangeMatch[1]) === range.min && parseInt(rangeMatch[2]) === range.max;
      }
      return false;
    });
    if (match) return match;
  }

  // Handle max-only cases like "Less than 7 days"
  if (range.max) {
    const match = options.find(opt => {
      const numMatch = opt.match(/(\d+)/);
      return numMatch && parseInt(numMatch[1]) === range.max;
    });
    return match || 'No max';
  }

  return 'No max';
};
